import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import moment from 'moment';
import { RootState } from 'reducers';
import { Globals } from 'utils';
import { Pagination, Input, DatePicker, Button } from 'components';
import { ViewIcon } from 'assets/icons';
import { ChatService } from 'services';
import ViewChat from './view-chat';

type IonChangeEvent = React.ChangeEvent<HTMLInputElement>;

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	date: ''
}

class AdminChat extends React.Component<Props> {

  debounce?: NodeJS.Timeout;

	state = {
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Chat',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (page: number = 1, withoutLoading: boolean = false) => {
		const res: any = await ChatService.admin.get({
			withoutLoading,
			page,
			...this.state.form,
			date: this.state.form.date && moment(this.state.form.date).format('YYYY-MM-DD')
		});
		this.setState({
			data: res.chats.rows,
			last_page: res.chats.count,
			page,
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(1, true));
	}

	change = async (value: string | number | boolean, target: keyof typeof INITIAL_STATE) => {
		const form = Globals.clone(this.state.form);
		form[target] = value;
		await this.setState({ form });

		if (this.debounce) clearTimeout(this.debounce);
		this.debounce = setTimeout(async () => this.load(1, true), 800);
	}

	view = (item: any) => {
		this.setState({
			visible: true,
			item
		},() => {
			Globals.hideTooltip();
		});
	} 

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		});
	}

  cleanFilters = async () => {
    await this.setState({ form: { ...INITIAL_STATE } });
		this.load(1, true);
  }

	render() {
		const { form, visible } = this.state;
    const canCleanFilters = JSON.stringify(this.state.form) !== JSON.stringify(INITIAL_STATE);

		return (
			<div id="admin-chat">
				<div className={ `container-modal-right ${ visible ? 'active' : '' }` }>
					{visible && (
						<ViewChat item={ this.state.item } onClose={ () => this.onClose() } />
					)}
				</div>

				<section className="filters">
					<div className="main-filter">
						<Input
							className="filter-x2"
							label="Buscar"
							placeholder="Especialidad"
							value={form.search}
							onChange={(e: IonChangeEvent) => this.change(e.target.value, 'search')}
						/>
					</div>
					<DatePicker
						label="Fecha"
						placeholder="Fecha"
						maxDate={moment().toDate()}
						onChange={(v: string) => this.change(v, 'date')}
						value={form.date}
					/>
					{canCleanFilters && (
						<Button clear onClick={this.cleanFilters}>
							Limpiar
						</Button>
					)}
				</section>

				<div className="rg-table">
					<table>
						<thead>
							<tr>
								<th>Fecha de registro</th>
								<th>ID del Chat</th>
								<th>Paciente</th>
								<th>C.I.</th>
								<th>Médico</th>
								<th>Especialidad</th>
								<th>Acciones</th>
							</tr>
						</thead>
						<tbody>
							{this.state.data.map((i: any, index: number) => (
								<tr key={index}>
									<td>{ moment(i.created_at).isValid() ? moment(i.created_at).format('DD/MM/YYYY') : '' }</td>
									<td>{ i.number_format }</td>
									<td>{ i.user?.full_name || '' }</td>
									<td>{ i.user?.full_document || '' }</td>
									<td>{ i.doctor?.full_name || '' }</td>
									<td>{ i.doctor?.specialty?.name || '' }</td>
									<td>
										<div className="actions">
											<img
												src={ViewIcon}
												alt="Ver"
												title="Ver"
												onClick={() => this.view(i)}
											/>
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>

					{!this.state.data.length && (
						<p className="no-items">No se encontraron resultados</p>
					)}
				</div>

				<Pagination
					pages={this.state.last_page}
					active={this.state.page}
					onChange={(page: number) => this.load(page)}
				/>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(AdminChat);